var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex justify-center align-center flex-column",class:{'pa-3': _vm.outline },attrs:{"flat":!_vm.outline}},[_c('div',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.label))]),_vm._t("value",function(){return [_c('div',{staticClass:"text-h5 font-weight-black"},[_vm._v(_vm._s(_vm.value)+" ")])]},null,{ value: _vm.value })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }